import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function ValidateInputLength(minLengthLimit?: number, maxLengthLimit?: number): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    let error: any = null;
    if (minLengthLimit && String(control.value).length < minLengthLimit) {
      error = { 
        minLengthLimit
      };
    }
    if (maxLengthLimit && String(control.value).length > maxLengthLimit) {
      error = { 
        ...error,
        maxLengthLimit
      };
    }
    return error;
    
  }
 
}